import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import CustomTree from '@components/CustomTree';
import JustificationModal from '@components/JustificationModal';

import { getSectionsLocked, updateSectionsLocked } from '@actions/typeUsers'
import { getAllSectionTree } from '@actions/sections'
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'
import { Button } from 'primereact/button';

import './style.scss'

class AllowedSections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      btnSubmitLoading: false,
      treeAll:[],
      sectionsLocked: [],
      sectionsLockedOr: [],
      sectionsCollapse: [1],
      id: "",
      tipo: "",
      loadingTree: false,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
  }

  async componentDidMount () {
    const { history, getSectionsLocked } = this.props
    if(!history.location.state?.id) return history.push('/type-users')
    this.setState({
      id: history.location.state?.id,
      tipo: history.location.state?.tipo,
    });
    await this.onGetTree()
    const response = await getSectionsLocked( history.location.state.id )
    if (!response?.status) {
      let getSectionsId = []
      if (response.data.length) getSectionsId = response.data.map(item => item.seccion)
      this.setState({ sectionsLocked: [...getSectionsId], sectionsLockedOr: [...getSectionsId] });
    }

    return this.setState({
      loadingPage: false,
    })
  }

  onGetTree = async () => {
    const { getAllSectionTree } = this.props

    const response = await getAllSectionTree()
    if (!response?.status) {
      const formatTree = response?.data
      const children = this.formattedSectionTree(formatTree.hijos)
      formatTree.children = children
      formatTree.key = formatTree.id
      formatTree.label = getValueLanguageObj(formatTree.nombre)
      delete formatTree.hijos
      delete formatTree.id_padre

      this.setState({ treeAll: [formatTree] || {} })
    }

  }

  formattedSectionTree = (data) => data.map(item => {
    item.label = getValueLanguageObj(item.nombre)
    item.key = item.id
    item.children = item.hijos
    item.parentKey = item.id_padre
    delete item.hijos
    delete item.id_padre

    if (item.children) this.formattedSectionTree(item.children)
    return item
  })

  onConfirmUpdateSectionsLocked = async () => {
    const { t } = this.props
    const { sectionsLocked, sectionsLockedOr } = this.state
    if (JSON.stringify(sectionsLocked) === JSON.stringify(sectionsLockedOr)) {
      return confirmDialog({
        header: t('Actualizar secciones bloqueadas'),
        message: t('No se ha encontrado ningún cambio'),
        icon: `pi pi-exclamation-triangle`,
        acceptLabel: t('Cerrar'),
        rejectClassName: 'hide-component',
        accept: () => {},
      });
    }
    return this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => this.onUpdateSectionsLocked(justification),
      },
    });
  }

  onUpdateSectionsLocked = async (justification) => {
    const { t, updateSectionsLocked, history, sendActionToBitacora } = this.props
    const { sectionsLocked, id, tipo } = this.state
    this.setState({btnSubmitLoading: true})

    const response = await updateSectionsLocked({typeUser: id, sectionsLocked})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actSecNoPermitadas',
        reason: `${tipo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)

      this.setState({ btnSubmitLoading: false });
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/type-users'),
        onHide: () => history.push('/type-users')
      });
    }
  }

  onValidateSectionLocked = (newSectionsLocked) => {
    this.setState({loadingTree: true, btnSubmitLoading: true}, () => {
      this.setState({sectionsLocked: newSectionsLocked, loadingTree: false, btnSubmitLoading: false})
    })

  }

  onSectionCollapse = ({key}) => {
    const { sectionsCollapse } = this.state
    let newSectionsCollapse = [...sectionsCollapse]
    const isCollapse = sectionsCollapse.find(item => item === key)
    if (isCollapse) {
      newSectionsCollapse = newSectionsCollapse.filter(item => item !== key) || []
      return this.setState({sectionsCollapse: newSectionsCollapse})
    }

    newSectionsCollapse.push(key)

    return this.setState({sectionsCollapse: newSectionsCollapse})
  }

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  render() {
    const { t } = this.props;
    const { loadingPage, treeAll, sectionsLocked, loadingTree, btnSubmitLoading, showModalJustification, tipo, sectionsCollapse } = this.state;

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Secciones permitidas')} linkText={t("Ir al listado")} to="/type-users" />
          <div className='card p-grid'>
            <div className="p-col-12 footer-btn">
              <div className="p-d-flex p-jc-end">
                <Button
                  label={t('Actualizar')}
                  onClick={this.onConfirmUpdateSectionsLocked}
                  className="p-button-primary"
                  loading={btnSubmitLoading}
                />
              </div>
            </div>
            <div className='p-col-12'>
            {t('Deselecciona las secciones a las cuales no tendra acceso el tipo de usuario {{TIPO}}', {TIPO: tipo})}
            </div>
            <div className='p-col-12 container-tree'>
              { !loadingTree && (
              <CustomTree
                value={treeAll}
                sectionsLocked={sectionsLocked}
                validateSectionsLocked={this.onValidateSectionLocked}
                sectionsCollapse={sectionsCollapse}
                onSectionsCollapse={this.onSectionCollapse}
              />
              )
              }
            </div>
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,

});

const mapDispatchToProps = {
  getSectionsLocked,
  getAllSectionTree,
  updateSectionsLocked,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(AllowedSections);
